import React from "react";

type PaginationV4Props = {
  page: number;
  pageCount: number;
  /** จำนวนรายการทั้งหมด: ใส่เมื่อรู้ เพื่อแสดง "แสดง a–b จาก n รายการ" */
  total?: number;
  pageSize?: number;
  disabled?: boolean;
  onChange: (page: number) => void;
};

/** เลขหน้าที่แสดง: หน้าแรก หน้าสุดท้าย และรอบหน้าปัจจุบัน, null = "…" */
export const pageItems = (page: number, pageCount: number): (number | null)[] => {
  const items: (number | null)[] = [];
  for (let n = 1; n <= pageCount; n += 1) {
    if (n === 1 || n === pageCount || Math.abs(n - page) <= 1) {
      items.push(n);
    } else if (items[items.length - 1] !== null) {
      items.push(null);
    }
  }
  return items;
};

/** แถบเปลี่ยนหน้าใต้ตาราง (class hv4-pager ใน HISV4.scss) */
const PaginationV4 = (props: PaginationV4Props) => {
  const pageCount = Math.max(1, props.pageCount);
  const page = Math.min(Math.max(1, props.page), pageCount);
  const size = props.pageSize ?? 0;
  const total = props.total;
  const from = total && size ? (page - 1) * size + 1 : 0;
  const to = total && size ? Math.min(page * size, total) : 0;

  return (
    <nav className="hv4-pager" aria-label="เปลี่ยนหน้า">
      {total !== undefined && (
        <span className="hv4-pager-text">
          {total && size ? `แสดง ${from}–${to} จาก ${total} รายการ` : `${total} รายการ`}
        </span>
      )}
      <span className="hv4-pager-pages">
        <button
          type="button"
          className="hv4-pager-btn"
          aria-label="หน้าก่อนหน้า"
          disabled={props.disabled || page <= 1}
          onClick={() => props.onChange(page - 1)}
        >
          ‹
        </button>
        {pageItems(page, pageCount).map((n, i) =>
          n === null ? (
            <span key={`gap-${i}`} className="hv4-pager-gap">
              …
            </span>
          ) : (
            <button
              key={n}
              type="button"
              className={`hv4-pager-btn${n === page ? " hv4-pager-btn--on" : ""}`}
              aria-current={n === page ? "page" : undefined}
              disabled={props.disabled}
              onClick={() => n !== page && props.onChange(n)}
            >
              {n}
            </button>
          ),
        )}
        <button
          type="button"
          className="hv4-pager-btn"
          aria-label="หน้าถัดไป"
          disabled={props.disabled || page >= pageCount}
          onClick={() => props.onChange(page + 1)}
        >
          ›
        </button>
      </span>
    </nav>
  );
};

export default PaginationV4;
